export class DroneSpecificationDto {
    public seq!: number;
    public manufacturer!: string;
    public name!: string;
    public maximumHumidity!: number;
    public maximumTemperature!: number;
    public minimumHumidity!: number;
    public minimumTemperature!: number;
    public windResistance!: number;
}